module.exports = __webpack_public_path__ + "img/logo.8d161433.png";